import { useCaptionStore } from '../../state/captionState'
import './CaptionBar.css'

/**
 * Mirrors the current spoken line as on-screen text. Always mounted so the
 * aria-live region reliably announces updates to screen readers.
 */
export const CaptionBar = () => {
  const caption = useCaptionStore((state) => state.caption)

  return (
    <div className="captionBar" aria-live="polite" role="status">
      {caption && <span className="captionText">{caption}</span>}
    </div>
  )
}
